import { render, staticRenderFns } from "./ConnectedProject.vue?vue&type=template&id=109e2708&"
import script from "./ConnectedProject.vue?vue&type=script&lang=js&"
export * from "./ConnectedProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports